<template>
  <div :class="{ 'pb-float': true, [float]: true }">
    <slot />
  </div>
</template>
<script>
export default {
  name: "PbFloat",
  props: {
    float: {
      type: String, // "left" | "right"
      default: () => "left"
    }
  },
  methods: {}
};
</script>
<style lang='scss'>
.pb-float {
  position: relative;

  &.left {
    float: left;
  }

  &.right {
    float: right;
  }
}
</style>